// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FloorExpansion, FloorExpansionT, verifyFloorExpansion } from "./floor-expansion";
import {
  MessageToNodeValueEntry,
  MessageToNodeValueEntryT,
  verifyMessageToNodeValueEntry,
} from "./message-to-node-value-entry";

/**
 * Outbound floor template.
 *
 * Authored once and expanded per floor into `msg_to_node` entries. The floor
 * is carried in the key's message `position`.
 */
export class MsgToNodeTemplate implements flatbuffers.IUnpackableObject<MsgToNodeTemplateT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MsgToNodeTemplate {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMsgToNodeTemplate(
    bb: flatbuffers.ByteBuffer,
    obj?: MsgToNodeTemplate,
  ): MsgToNodeTemplate {
    return (obj || new MsgToNodeTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMsgToNodeTemplate(
    bb: flatbuffers.ByteBuffer,
    obj?: MsgToNodeTemplate,
  ): MsgToNodeTemplate {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MsgToNodeTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  entry(obj?: MessageToNodeValueEntry): MessageToNodeValueEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new MessageToNodeValueEntry()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  expansion(obj?: FloorExpansion): FloorExpansion | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new FloorExpansion()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startMsgToNodeTemplate(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addEntry(builder: flatbuffers.Builder, entryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, entryOffset, 0);
  }

  static addExpansion(builder: flatbuffers.Builder, expansionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, expansionOffset, 0);
  }

  static endMsgToNodeTemplate(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // entry
    builder.requiredField(offset, 6); // expansion
    return offset;
  }

  unpack(): MsgToNodeTemplateT {
    return new MsgToNodeTemplateT(
      this.entry() !== null ? this.entry()!.unpack() : null,
      this.expansion() !== null ? this.expansion()!.unpack() : null,
    );
  }

  unpackTo(_o: MsgToNodeTemplateT): void {
    _o.entry = this.entry() !== null ? this.entry()!.unpack() : null;
    _o.expansion = this.expansion() !== null ? this.expansion()!.unpack() : null;
  }

  unpackFields(...fields: string[]): MsgToNodeTemplateT {
    const t = new MsgToNodeTemplateT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("entry")) {
      t.entry = this.entry() !== null ? this.entry()!.unpack() : null;
    }
    if (fieldSet.has("expansion")) {
      t.expansion = this.expansion() !== null ? this.expansion()!.unpack() : null;
    }
    return t;
  }
}

export class MsgToNodeTemplateT implements flatbuffers.IGeneratedObject {
  constructor(
    public entry: MessageToNodeValueEntryT | null = null,
    public expansion: FloorExpansionT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.entry === null || this.entry === undefined) {
      throw new Error('Required field "entry" is not set');
    }
    if (this.expansion === null || this.expansion === undefined) {
      throw new Error('Required field "expansion" is not set');
    }
    const entry = this.entry !== null ? this.entry!.pack(builder) : 0;
    const expansion = this.expansion !== null ? this.expansion!.pack(builder) : 0;

    MsgToNodeTemplate.startMsgToNodeTemplate(builder);
    MsgToNodeTemplate.addEntry(builder, entry);
    MsgToNodeTemplate.addExpansion(builder, expansion);

    return MsgToNodeTemplate.endMsgToNodeTemplate(builder);
  }

  clone(): MsgToNodeTemplateT {
    const obj = new MsgToNodeTemplateT();
    obj.entry = this.entry !== null ? this.entry!.clone() : null;
    obj.expansion = this.expansion !== null ? this.expansion!.clone() : null;
    return obj;
  }

  equals(other: MsgToNodeTemplateT): boolean {
    if (this.entry !== null && other.entry !== null) {
      if (!this.entry!.equals(other.entry!)) return false;
    } else if (this.entry !== other.entry) return false;
    if (this.expansion !== null && other.expansion !== null) {
      if (!this.expansion!.equals(other.expansion!)) return false;
    } else if (this.expansion !== other.expansion) return false;
    return true;
  }
}

export function verifyMsgToNodeTemplate(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessageToNodeValueEntry(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "entry");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyFloorExpansion(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "expansion");
  } finally {
    verifier.popDepth();
  }
}
